import React from 'react';
import PropTypes from 'prop-types';
import pallet from 'constants/colors';

const styles = {
  container: {
    margin: '6px 12px',
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1 0 auto',
  },
  button: {
    color: 'white',
    borderRadius: 4,
    backgroundColor: pallet.mainButton,
    textDecoration: 'none',
    outline: 'none',
    border: 'none',
    fontWeight: 500,
    height: '100%',
    width: '100%',
    paddingLeft: 24,
    paddingRight: 24,
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
};

const KButtonLink = ({ href, label }) => (
  <div style={styles.container}>
    <a style={styles.button} href={href}>

      {label}
    </a>
  </div>
);

KButtonLink.propTypes = {
  label: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
};

export default KButtonLink;



// WEBPACK FOOTER //
// ./src/components/KJRN/KButtonLink.js